import React from 'react';
import { motion } from 'framer-motion';
import './MobilePrompt.css';

/**
 * MobilePrompt Component
 * Shows a friendly message to mobile users suggesting they visit on desktop
 * Only renders on mobile devices - desktop users never see this
 */
const MobilePrompt = () => {
  return (
    <div className="mobile-prompt-container">
      <motion.div
        className="mobile-prompt-content"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
      >
        {/* Decorative header */}
        <div className="mobile-prompt-header">
          <svg viewBox="0 0 100 100" className="mobile-prompt-icon">
            {/* Computer monitor icon */}
            <rect x="15" y="25" width="70" height="50" rx="4" fill="var(--color-deep-brown)" opacity="0.8" />
            <rect x="20" y="30" width="60" height="38" fill="var(--color-parchment)" />
            <rect x="42" y="75" width="16" height="8" fill="var(--color-deep-brown)" opacity="0.6" />
            <rect x="30" y="83" width="40" height="3" rx="1.5" fill="var(--color-deep-brown)" opacity="0.6" />
          </svg>
        </div>

        {/* Main message */}
        <motion.h1
          className="mobile-prompt-title"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          Welcome Home
        </motion.h1>

        <motion.div
          className="mobile-prompt-message"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.5 }}
        >
          <p className="mobile-prompt-main-text">
            This experience is best enjoyed on a computer with a larger screen.
          </p>
          <p className="mobile-prompt-sub-text">
            Our cozy digital home is designed for desktop browsers, where you can fully explore the interactive wall, shared desk, and all the intimate spaces we've created together.
          </p>
        </motion.div>

        {/* Suggestion */}
        <motion.div
          className="mobile-prompt-suggestion"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7, duration: 0.5 }}
        >
          <div className="mobile-prompt-suggestion-icon">💻</div>
          <p>Please visit us on your desktop or laptop computer for the full experience.</p>
        </motion.div>

        {/* URL hint */}
        <motion.div
          className="mobile-prompt-url"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 0.5 }}
        >
          <code>omi-henry.com</code>
        </motion.div>

        {/* Footer note */}
        <motion.p
          className="mobile-prompt-footer"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2, duration: 0.5 }}
        >
          Mobile optimization coming soon...
        </motion.p>
      </motion.div>
    </div>
  );
};

export default MobilePrompt;
